import { applicationConfig } from "../../environmentConfiguration";
import { chatBotFeature } from "./chat/ChatBotFeature";
import { Features } from "./feature.enum";
import { IFeature } from "./iFeature";
import { imageGenerationFeature } from "./image-generation/ImageGenerationFeature";
import { schornBoxFeature } from "./schornbox/SchornBoxFeature";
import { summaryFeature } from "./summary/SummaryFeature";
import { transcriptionFeature } from "./transcription/TranscriptionFeature";
import { translationFeature } from "./translation/TranslationFeature";

const registeredFeatures: IFeature[] = [
  chatBotFeature,
  imageGenerationFeature,
  transcriptionFeature,
  summaryFeature,
  translationFeature,
  schornBoxFeature,
];

export const enabledFeatures = (): IFeature[] => {
  let features = [...registeredFeatures];
  // #59692 hide imageGenerationFeature when the EnableImageGeneration feature flag is disabled

  if (!applicationConfig?.featureFlags?.enableImageGeneration) {
    features = features.filter((feature: IFeature) => feature.id !== Features.ImageGeneration);
  }

  return features;
};
